/*
===============================|> AUTH APIS <|===============================
01 |--> Login Api
02 |--> Register Api
03 |--> reset password:
|--> send email 
|--> send otp api and verify otp 
|--> change password
===============================|> AUTH APIS <|===============================
*/

import axios from "@/utils/axios-config";

// 01 --> Login api
const logInByEmail = async (handshake, username, password) => {
  const data = JSON.stringify({ username, password });
  const config = {
    method: "post",
    url: "/customer/login",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  console.log("login config", config);
  try {
    const req = await axios(config);
    console.log("login success", req);
    return req;
  } catch (error) {
    return error;
  }
};

// 02 --> Login api
const logInByMobile = async (handshake, mobilenumber) => {
  const data = JSON.stringify({
    mobilenumber,
    otptype: "login",
    email: "",
    resendotp: "",
    oldmobile: "",
  });
  const config = {
    method: "post",
    url: "/customer/login/otp/send",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  // console.log("logInByMobile config", config);
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const logInVerifyOtp = async (
  handshake,
  mobilenumber,
  otpcode,
) => {
  const data = JSON.stringify({
    mobilenumber,
    otpcode,
    otptype: "login",
    oldmobile: ""
  });
  const config = {
    method: "post",
    url: "/customer/login/otp/verify",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const forgetVerifyOtp = async (
  handshake,
  mobilenumber,
  otpcode,
  otptype = "forgot"
) => {
  const data = JSON.stringify({
    mobilenumber: `00966${mobilenumber?.slice(-9)}`,
    otpcode,
    otptype,
    oldmobile: ""
  });
  const config = {
    method: "post",
    url: "/customer/forget/otp/verify",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 03 --> Register api
const register = async (
  handshake,
  email,
  firstName,
  lastName,
  password,
  phone_number
) => {
  const data = JSON.stringify({
    email,
    firstName,
    lastName,
    password,
    phone_number,
    profile_picture: "unknown",
    dateOfBirth: "2001-01-01",
    gender: "1",
  });
  const config = {
    method: "post",
    url: "/customer/register",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04 --> reset password: 1--> Send otp email api
const forgetSendOtpEmail = async (handshake, email) => {
  const data = JSON.stringify({
    // mobilenumber: "",
    // otptype: "forget",
    email,
    // resendotp: "",
    // oldmobile: ""
  });
  const config = {
    method: "post",
    url: "/customer/emailResetToken",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const forgetSendOtpMobile = async (handshake, mobilenumber) => {
  const data = JSON.stringify({
    mobilenumber: `00966${mobilenumber?.slice(-9)}`,
    otptype: "forgot",
    email: "",
    resendotp: "",
    oldmobile: ""
  });
  const config = {
    method: "post",
    url: "/customer/forget/otp/send",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04 --> reset password: 2--> Send otp to user email api
// TODO need to check backend required admin token or we should send from our side
const sendOtpToEmail = async (handshake, receiver, name, otp) => {
  const data = JSON.stringify({ receiver, name, otp });
  const config = {
    method: "post",
    url: "/email/otp",
    Headers: {
      Authorization: `Bearer ${handshake}`,
      admin: `Bearer ${process.env?.NEXT_PUBLIC_ADMIN_TOKEN}`,
    },
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 05 --> reset password: 3--> verify otp and change new password api
const resetNewPassword = async (
  handshake,
  email,
  newPassword,
  confirmPassword,
  resetToken
) => {
  const data = JSON.stringify({
    email,
    newPassword,
    confirmPassword,
    resetToken,
  });
  const config = {
    method: "post",
    url: "/customer/forgetPassword",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const resetNewPasswordByMobile = async (
  handshake,
  mobilenumber,
  password
) => {
  const data = JSON.stringify({
    mobilenumber: `00966${mobilenumber?.slice(-9)}`,
    password
  });
  const config = {
    method: "post",
    url: "/customer/forget/resetpassword",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const registerSendOtp = async (
  handshake,
  mobilenumber,
  email,
) => {
  const data = JSON.stringify({
    mobilenumber,
    otptype: "register",
    email,
    resendotp: "",
    oldmobile: ""
  });
  const config = {
    method: "post",
    url: "/customer/register/otp/send",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const registerVerifyOtp = async (
  handshake,
  mobilenumber,
  otpcode,
) => {
  const data = JSON.stringify({
    mobilenumber,
    otpcode,
    otptype: "register",
    oldmobile: ""
  });
  const config = {
    method: "post",
    url: "/customer/register/otp/verify",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const registerCreate = async (
  handshake,
  mobile,
  password,
  firstname,
  lastname,
  email
) => {
  const data = JSON.stringify({
    mobile,
    password,
    firstname,
    lastname,
    email
  });
  const config = {
    method: "post",
    url: "/customer/register/account/create",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  logInByEmail,
  logInByMobile,
  logInVerifyOtp,
  forgetVerifyOtp,
  register,
  forgetSendOtpEmail,
  forgetSendOtpMobile,
  sendOtpToEmail,
  resetNewPassword,
  resetNewPasswordByMobile,
  registerSendOtp,
  registerVerifyOtp,
  registerCreate
};
